import fetcher from 'src/utils/fetcher';

const CONTEXT_BANNER_CLOSE_URL = '/shards/search/resume/context_vacancy/banner_close';

declare global {
    interface FetcherGetApi {
        [CONTEXT_BANNER_CLOSE_URL]: {
            queryParams: {
                isContextVacancyDeleting: boolean;
            };
            response: void;
        };
    }
}

export const fetchBannerClose = async (isContextVacancyDeleting = false): Promise<void> => {
    try {
        await fetcher.get(CONTEXT_BANNER_CLOSE_URL, { params: { isContextVacancyDeleting } });
    } catch (e) {
        console.error(e);
    }
};
